import { render, staticRenderFns } from "./ModalTransference.vue?vue&type=template&id=40f9eda4&scoped=true"
import script from "./ModalTransference.vue?vue&type=script&lang=js"
export * from "./ModalTransference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9eda4",
  null
  
)

export default component.exports